<template>
  <div class="orderm">
    <div class="sticky">
        <div class="header">
            <img src="@/assets/mobile/back.png" alt="" @click="back()">
            <p>我的订单</p>
        </div>
    </div>
    <div class="orderbox" @scroll.passive="handleScroll" ref="pointm">
        <ul>
            <li v-for="(item,index) in tableData" :key="index">
                <p>
                    <span>{{item.createtime}}</span>
                    <span v-if="item.status==0">等待付款</span>
                    <span v-if="item.status==1">已付款</span>
                    <span v-if="item.status==2">订单取消</span>
                </p>
                <p>
                    <span>{{item.title}}</span>
                    <span>￥{{item.pay_money}}</span>
                </p>
                <!-- <p>
                    <span>有效期:</span>
                    <span>{{item.day}}天</span>
                </p> -->
                <p>
                    <span>订单编号:</span>
                    <span>{{item.order_sn}}</span>
                </p>
                <div class="buttonbox" v-show="item.status==0" @click="payPay(item.id)">
                    <p>继续支付</p>
                </div>
            </li>
        </ul>
    </div>
  </div>
</template>

<script>
import { orderGetList,payPay,orderQuery,userInfo } from "@/api/user";
export default { 
    data(){
        return {
            tableData: [

            ],
            page: 1,
            last_page:1
        }
    },
    mounted() {
        this.orderGetList();
    },
    methods:{
        handleScroll(){
            if (this.$refs.pointm.clientHeight + this.$refs.pointm.scrollTop === this.$refs.pointm.scrollHeight) {
                if(this.page<this.last_page){
                    this.page++
                    this.orderGetList()
                }
            }
        },
        back(){
            this.$router.back()
        },
        orderGetList() {
            orderGetList({ page: this.page }).then((res) => {
                if(this.page==1){
                    this.tableData=res.data.data.data
                }else{
                    this.tableData = this.tableData.concat(res.data.data.data)
                }
                this.last_page = res.data.data.last_page;
            });
        },
        payPay(id) {
            let pay = {
                id: id,
                pay_type: "mp",
            };
            payPay(pay).then((res) => {
				if(res.code == 0) {
					 this.callWeChatPay(res.data)
				}else {
					this.$message({
					    message: res.message,
					});
				}
            });
        },
		callWeChatPay(params) {
		    // 配置微信JSAPI
		    wx.config({
		        debug: false, // 开发模式下设置为true，生产模式下设置为false
		        appId: params.appId,
		        timestamp: params.timeStamp,
		        nonceStr: params.nonceStr,
		        signature: params.signature,
		        jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表
		    });
		    
		    // 调起微信支付
		    wx.ready(() => {
		        wx.chooseWXPay({
		            timestamp: params.timeStamp,
		            nonceStr: params.nonceStr,
		            package: params.package,
		            signType: params.signType,
		            paySign: params.paySign,
		            success(res) {
						userInfo().then(res=>{
						  this.$store.userInfo = res.data
						  that.$router.push({ path: '/'});
						});
		                location.reload();
		            },
		            fail(err) {
		                console.error('支付失败', err);
		            }
		        });
		    });
		},
    }
}
</script>

<style lang="less">
    .orderm{
        background-color: #f4f5f7;
        min-height: 100vh;
        .sticky{
            position: sticky;
            top: 0;
            left: 0;
            width: 100%;
            background-color: #f4f5f7;
        }
        .header{
            display: flex;
            align-items: center;
            height: 60px;
            img{
                height: 18px;
                padding: 0 20px;
            }
            p{
                flex:1 0 10%;
                text-align: center;
                font-size: 18px;
                font-weight: 700;
                padding-right: 30px;
            }
        }
        .orderbox{
            height: calc(100vh - 60px);
            overflow-y: scroll;
            padding: 20px;
            li{
                width: 100%;
                padding: 12px 16px;
                background: #ffffff;
                border-radius: 8px;
                margin-bottom: 16px;
                p{
                    display: flex;
                    justify-content: space-between;
                }
                p:nth-child(1){
                    span:nth-child(1){
                        font-size: 12px;
                        color: #999;
                        line-height: 22px;
                    }
                    span:nth-child(2){
                        color: #ff6543;
                        font-size: 12px;
                        line-height: 22px;
                    }
                }
                p:nth-child(2){
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 28px;
                }
                p:nth-child(3){
                    font-size: 12px;
                    color: #999;
                    line-height: 22px;
                }
                p:nth-child(4){
                    font-size: 12px;
                    color: #999;
                    line-height: 22px;
                }
                .buttonbox{
                    display: flex;
                    justify-content: flex-end;
                    padding-top: 8px;
                    margin-top: 6px;
                    border-top: 1px solid #f1f1f1;
                    p{
                        cursor: pointer;
                        font-size: 12px;
                        display: inline-flex;
                        justify-content: center;
                        align-items: center;
                        width: 80px;
                        height: 26px;
                        border: 1px solid #f1f1f1;
                        border-radius: 26px;
                    }
                }
            }
        }
    }
</style>